var app = angular.module('leonardo');

var ButtonDirective = function(ConfigThemeService, $timeout) {
  return {
    restrict: 'C',
    scope: {
      ngClass: '=?'
    },
    link: function (scope, element) {

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          var color = ConfigThemeService.config.theme_config.secondaryColor;
          scope.classes = element.attr('class');
          if (scope.classes.includes('disabled')){
            color = ConfigThemeService.getColor('tertiaryColor', 0.5);
          }
          else if (scope.classes.includes('btn-black')){
            color = ConfigThemeService.config.theme_config.primaryColor;
          }
          else if (scope.classes.includes('btn-cancel')){
            color = ConfigThemeService.config.theme_config.tertiaryColor;
          }
          else if (scope.classes.includes('btn-delete')){
            color = ConfigThemeService.config.theme_config.errorColor;
          }
          else if (scope.classes.includes('btn-orange')){
            color = ConfigThemeService.config.theme_config.warningColor;
          }
          else if (scope.classes.includes('btn-success')){
            color = ConfigThemeService.config.theme_config.successColor;
          }
          element.css('background-color', color);
        });
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('btn', ['ConfigThemeService', '$timeout', ButtonDirective]);
